import { Users, Search, FileText } from "lucide-react";

const BENEFITS = [
  {
    Icon: Search,
    title: "Post jobs and find providers",
    description:
      "Share open jobs and shifts, review provider profiles, and connect with healthcare professionals.",
  },
  {
    Icon: FileText,
    title: "Keep credentials organized",
    description:
      "Track provider licenses and credential requirements in one place.",
  },
  {
    Icon: Users,
    title: "Support your existing team",
    description:
      "Coordinate schedules, communicate with providers, and manage access across your organization.",
  },
];

export function OrgPitchContent() {
  return (
    <div>
      <p className="text-xs font-medium uppercase tracking-widest text-white/65">
        Saile for organizations
      </p>
      <h1 className="mt-4 max-w-[16ch] text-4xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl">
        Hire providers. Support your team.
      </h1>
      <p className="mt-5 max-w-[42ch] text-base leading-7 text-white/80 sm:text-lg sm:leading-8">
        Find healthcare professionals and manage the credentials, schedules, and
        communication your team depends on.
      </p>

      <ul className="mt-9 divide-y divide-white/15 border-y border-white/15">
        {BENEFITS.map(({ Icon, title, description }) => (
          <li
            key={title}
            className="flex items-start gap-4 py-5 sm:gap-5 sm:py-6"
          >
            <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white ring-1 ring-inset ring-white/15">
              <Icon className="size-5" aria-hidden="true" />
            </span>
            <div className="min-w-0 pt-0.5">
              <h2 className="text-base font-semibold leading-6 text-white sm:text-lg">
                {title}
              </h2>
              <p className="mt-1.5 text-sm leading-6 text-white/80 sm:text-base">
                {description}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
